
import React from 'react';
import { VezgoConnectPage } from '@/components/vezgo-connect/VezgoConnectPage';
import { VezgoProviderWrapper } from '@/providers/vezgo/components/VezgoProviderWrapper';
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { PageContainer } from "@/components/ui/PageContainer";

export default function VezgoConnect() {
  return (
    <VezgoProviderWrapper initialProvider="vezgo">
      <div className="flex-1">
        <SidebarInset>
          <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4 sticky top-0 bg-background z-10">
            <SidebarTrigger className="-ml-2" />
            <Separator orientation="vertical" className="h-6" />
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/investments">Investments</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator>
                  <ChevronRight className="h-4 w-4" />
                </BreadcrumbSeparator>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/investments/connect">Connect</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator>
                  <ChevronRight className="h-4 w-4" />
                </BreadcrumbSeparator>
                <BreadcrumbItem>
                  <BreadcrumbPage>Vezgo</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </header>
          
          <PageContainer maxWidthClassName="max-w-[960px]">
            <VezgoConnectPage />
          </PageContainer>
        </SidebarInset>
      </div>
    </VezgoProviderWrapper>
  );
}
